module.exports = __webpack_public_path__ + "img/aut.e2634e96.svg";